module.exports = __webpack_public_path__ + "img/1.2f21a226.webp";